import { LiveTagStyling } from "@/components/Procedures/Checklist/utils/useValueWithBoundaries";

import { ChecklistStep } from "@/model/Checklist/ChecklistStep";
import { ProcedureListenerTag } from "@/model/Procedure/ProcedureListenerTag";
import { ProcedureNodeStep } from "@/model/Procedure/ProcedureNodeStep";
import {
	ProcedureNodeStepComment,
	SuggestionResponse,
} from "@/model/Procedure/ProcedureNodeStepComment";

export interface IProceduresSingleChecklist extends IActiveProcedureChecklist {
	editMode: boolean | undefined;
	materialHandling?: boolean;
}

export interface IActiveProcedureChecklist {
	activeSchemeId: number | undefined;
}

export interface IActiveProcedureChecklistWithEdit {
	activeSchemeId: number | undefined;
	editMode: boolean | undefined;
	SetActiveSchemeId: (schemeId: number) => void;
}

export interface IChecklistStep extends IActiveProcedureChecklist {
	step: ProcedureNodeStep;
	materialHandling?: boolean;
	showCommentsAndSuggestion?: boolean | undefined;
	highlightedStepId?: any;
}

export interface IChecklistStepTools extends IChecklistStep {
	toggleShowMeasurements: () => void;
	toggleShowStepLog: () => void;
	stepSkipped: boolean;
	skipStep: () => void;
	liveButtonStyle?: { button: React.CSSProperties } | undefined;
}

export type AggregatedStatusConfig = {
	button: string;
	svg: string;
};

export interface IChecklistOpenTask {
	suggestion: SuggestionResponse;
	step: ProcedureNodeStep;
	activeSchemeId: number | undefined;
	isOnlySuggestions?: boolean;
}

export interface IChecklistCommentStep {
	comment: ProcedureNodeStepComment;
	step: ProcedureNodeStep;
	activeSchemeId: number | undefined;
	isOnlyComments?: boolean;
}

export interface IStepLog extends IChecklistStep {
	showStepLog: boolean;
	toggleShowStepLog: () => void;
}

export interface IStepLogLine {
	logLine: ChecklistStep;
}

export interface IStepMeasurements {
	activeSchemeId: number | undefined;
	autoMode: boolean;
	listenerTags: Array<ProcedureListenerTag>;
	showMeasurements: boolean;
	step: ProcedureNodeStep;
	SetShowMeasurements: (show: boolean) => void;
	liveTagStatuses: { [key: string]: LiveTagStyling };
	values: { [key: string]: number | undefined };
}

export enum AggregatedMeasurementStatus {
	Ok = "ok",
	Alert = "alert",
	Wait = "wait",
	Skip = "skip",
	Default = "default",
}

export interface IListenerTagRow {
	isLast: boolean;
	listenerTag: ProcedureListenerTag;
	step: ProcedureNodeStep;
	activeSchemeId: number | undefined;
	liveTagStatuses: { [key: string]: LiveTagStyling };
	values: { [key: string]: number | undefined };
}

export type HeaderTools =
	| "close"
	| "edit"
	| "fullscreen"
	| "navigation"
	| "newManualChecklist"
	| "newNodeImportedChecklist"
	| "openInNewWindow"
	| "print";
